export enum IdFlagFiscalCode {
  Attribuzione = '1',
}
